const faLink = document.createElement('link');
faLink.id = 'fontawesome';
faLink.rel = 'stylesheet';
faLink.href = 'images/fontawesome/css/all.css';
faLink.crossOrigin = 'anonymous';

document.head.appendChild(faLink);

export const fontAwesomeStyles = new CSSStyleSheet();

faLink.onload = () => {
  const fa = Array.from(document.styleSheets)
    .find(s => (s.ownerNode as Element).matches('link#fontawesome'));

  if (!fa) return; // shouldn't happen

  Array.from(fa.cssRules).forEach(cssRule => {
    fontAwesomeStyles.insertRule(cssRule.cssText);
  });
};